import * as React from "react";
import { Route } from "react-router-dom";
import appRoutes from "./AppRoutes";
import { RouteType } from "./config";
import PageWrapper from "src/components/layout/PageWrapper";
import ConditionalRoute from "src/hooks/RequireAuth";
import RequireAuthMe from "src/hooks/RequireAuthMe";

/**
 * @function generateRoute
 * @description Genera las rutas a las cuales va a poder navegar
 * @param {ReturnType[]} routes
 * @returns {React.ReactNode}
 */
const generateRoute = (routes: RouteType[]): React.ReactNode => {
    return routes.map((route, index) => (
        route.index ? (
            <Route
                index
                path={route.path}
                element={
                    <ConditionalRoute idFunction={route.functionId} redirectTo="/401">
                      {route.requiredSubModule || route.requiredFeature ? (
                        <RequireAuthMe subModuleCode={route.requiredSubModule} requiredFeature={route.requiredFeature}>
                          <PageWrapper state={route.state}>{route.element}</PageWrapper>
                        </RequireAuthMe>
                      ) : (
                        <PageWrapper state={route.state}>{route.element}</PageWrapper>
                      )}
                    </ConditionalRoute>
                }
                key={index}
            />
        ) : (
            <Route
                path={route.path}
                element={<PageWrapper state={route.child ? undefined : route.state}>{route.element}</PageWrapper>}
                key={index}
                >
                {route.child && (
                    generateRoute(route.child)
                )}
            </Route>
        )
    ));
}

const routes: React.ReactNode = generateRoute(appRoutes);

export default routes;
